module.exports = __webpack_public_path__ + "static/media/course_1.c36a685c.png";